(function() {
    'use strict';
  
    function initCollectionSlider(section) {
      const viewport = section.querySelector('[data-collection-slider-viewport]');
      const track = section.querySelector('[data-collection-slider-track]');
      const prevButton = section.querySelector('[data-collection-slider-prev]');
      const nextButton = section.querySelector('[data-collection-slider-next]');
      const items = section.querySelectorAll('.collection-slider__item');
      
      if (!viewport || !track || items.length === 0) {
        return;
      }
  
      function updateButtons() {
        const scrollLeft = viewport.scrollLeft;
        const scrollWidth = viewport.scrollWidth;
        const clientWidth = viewport.clientWidth;
        const maxScrollLeft = scrollWidth - clientWidth;
  
        // Check if all items fit in viewport
        const allItemsFit = scrollWidth <= clientWidth;
  
        if (allItemsFit) {
          // All items fit - hide both buttons
          if (prevButton) {
            prevButton.classList.remove('is-visible');
            prevButton.disabled = true;
          }
          if (nextButton) {
            nextButton.classList.remove('is-visible');
            nextButton.disabled = true;
          }
        } else {
          // Check if first item is fully visible
          const firstItem = items[0];
          const firstItemVisible = firstItem && 
            firstItem.offsetLeft >= scrollLeft - 1;
  
          // Check if last item is fully visible
          const lastItem = items[items.length - 1];
          const lastItemVisible = lastItem && 
            (lastItem.offsetLeft + lastItem.offsetWidth) <= (scrollLeft + clientWidth + 1);
  
          // Show/hide buttons
          if (prevButton) {
            if (scrollLeft > 1 && !firstItemVisible) {
              prevButton.classList.add('is-visible');
              prevButton.disabled = false;
            } else {
              prevButton.classList.remove('is-visible');
              prevButton.disabled = true;
            }
          }
  
          if (nextButton) {
            if (scrollLeft < maxScrollLeft - 1 && !lastItemVisible) {
              nextButton.classList.add('is-visible');
              nextButton.disabled = false;
            } else {
              nextButton.classList.remove('is-visible');
              nextButton.disabled = true;
            }
          }
        }
      }
  
      function handlePrevClick(event) {
        event.preventDefault();
        const scrollAmount = viewport.clientWidth * 0.8;
        viewport.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      }
  
      function handleNextClick(event) {
        event.preventDefault();
        const scrollAmount = viewport.clientWidth * 0.8;
        viewport.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
  
      // Initialize
      updateButtons();
      viewport.addEventListener('scroll', updateButtons);
      
      if (prevButton) {
        prevButton.addEventListener('click', handlePrevClick);
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', handleNextClick);
      }
  
      // Handle resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateButtons();
        }, 100);
      });
    }
  
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        const sliders = document.querySelectorAll('[data-collection-slider]');
        sliders.forEach(initCollectionSlider);
      });
    } else {
      const sliders = document.querySelectorAll('[data-collection-slider]');
      sliders.forEach(initCollectionSlider);
    }
  
    // Initialize dynamically added sliders
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-collection-slider')) {
              initCollectionSlider(node);
            } else if (node.nodeType === 1 && node.querySelector) {
              const slider = node.querySelector('[data-collection-slider]');
              if (slider) {
                initCollectionSlider(slider);
              }
            }
          });
        });
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  })();